import { Link } from "react-router-dom";

interface DramaCardProps {
  id: string;
  title: string;
  poster: string;
  year: number;
  category: "movie" | "tv";
  genres: string[];
  rating: number;
  tags?: string[];
  badge?: string;
}

export default function DramaCard({
  id,
  title,
  poster,
  year,
  category,
  genres,
  rating,
  tags,
  badge,
}: DramaCardProps) {
  return (
    <Link
      to={`/detail/${id}`}
      className="group block cursor-pointer"
      data-product-shop
      title={`${title} ${genres.join(" ")} 国产影视`}
    >
      <div className="relative w-full aspect-[3/4.2] overflow-hidden rounded-lg bg-background-200">
        <img
          src={poster}
          alt={`${title} 海报`}
          title={`${title} ${genres.join(" ")}`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-80" />
        <span className="absolute top-2 left-2 flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-medium text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {rating.toFixed(1)}
        </span>
        {badge ? (
          <span className="absolute top-2 right-2 rounded-md bg-primary-600/90 px-1.5 py-0.5 text-[11px] text-background-50">
            {badge}
          </span>
        ) : null}
        <div className="absolute bottom-0 left-0 right-0 p-2.5">
          <p className="text-[11px] text-background-100/90">
            {year} · {category === "movie" ? "电影" : "电视剧"}
          </p>
          <h3 className="mt-0.5 truncate text-sm font-bold text-background-50">
            {title}
          </h3>
        </div>
      </div>
      <div className="mt-2 flex flex-wrap items-center gap-1">
        {genres.slice(0, 2).map((genre) => (
          <span
            key={genre}
            className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900"
          >
            {genre}
          </span>
        ))}
        {tags && tags.length > 0 ? (
          <span className="truncate text-[11px] text-foreground-600">{tags[0]}</span>
        ) : null}
      </div>
    </Link>
  );
}